import { b as useColorMode$1 } from "../../../index-CMqRvrZx.mjs";
const useColorMode = (opts = {}) => {
  const persist = opts.persist ?? false;
  const attribute = "data-bs-theme";
  const selector = "body";
  return useColorMode$1({
    attribute,
    selector,
    storageKey: persist === true ? `bv-color-${opts.attribute ?? attribute}-${opts.selector ?? selector}` : null,
    ...opts
  });
};
export {
  useColorMode
};
//# sourceMappingURL=index.mjs.map
